module.exports = __webpack_public_path__ + "img/20200512_161444.737d4019.jpg";